import { mapState, mapActions } from "vuex";
import { searchTypes, searchTermsCountLimit } from "../../config/bool-const";
import { INPUT_FIELDS, VALIDATIONS, SOCIAL } from '../../config/const';
import notifyMessages from "./notifyMessages";
import _ from 'lodash';

export default {
  mixins: [ notifyMessages ],
  created() {
    if(!this.languagesAreBusy && (!this.languages || !this.languages.length)) this.getLanguages(this.project_id);
    if(!this.includeInfluencersIsBusy && !this.includeInfluencersIsInitiated) this.getGroupsByProjectId({ projectId: this.project_id }).then((data) => {
      this.$store.commit('booleanSearch/SET_PAGINATED_RESOURCE_PRESERVE_SELECTED_OPTIONS', { key: 'include_influencers', resourceData: data, selectedOptions: this.includeInfluencersData, dataProp: 'group_id', reset: true });
    });
  },
  mounted () {
    this.prefillTagOptions();
  },
  data () {
    return {
      bioLocationTags: [],
      selectedTwitterSearches: []
    }
  },
  computed: {
    ...mapState({
      project_id: state => state.booleanSearch.project_id,
      languagesObject: state => state.languages.languages,
      countriesObject: state => state.countries.countries,
      mediaTypesObject: state => state.booleanSearch.media_types,
      outletCategories: state => state.booleanSearch.outlet_categories,
      tags: state => state.booleanSearch.tags,
      tagCategories: state => state.booleanSearch.tagCategories,
      includeOutlets: state => state.booleanSearch.include_outlets,
      excludeOutlets: state => state.booleanSearch.exclude_outlets,
      includeOutletGroups: state => state.booleanSearch.include_outlet_groups,
      excludeOutletGroups: state => state.booleanSearch.exclude_outlet_groups,
      states: state => state.booleanSearch.states,
      twitterLanguages: state => state.booleanSearch.twitter_languages,
      twitterFilters: state => state.booleanSearch.twitter_filters,
      twitterSearches: state => state.booleanSearch.twitter_searches,
      searchTermsFilters: state => state.booleanSearch.search_terms_filters,
      XChannelFilters: state => state.booleanSearch.x_channel_filters,
      includeInfluencers: state => state.booleanSearch.include_influencers,
      influencerGroups: state => state.influencerGroups.data
    }),
    isDisabled() {
      return ['twitter'].includes(this.model.search_type);
    },
    selectedSearchType() {
      let searchType = {};
      if (this.model && this.model.search_type) {
        if (Array.isArray(this.model.search_type)) {
          searchType = searchTypes.filter(type => this.model.search_type.includes(type.value)) || [];
        }
        else {
          searchType = searchTypes.find(type => type.value === this.model.search_type) || {};
        }
      }
      return searchType;
    },
    toggleMultiSyntax() { return this.model.is_multi },
    languagesAreBusy() { return this.languagesObject.isBusy },
    languages() { return this.languagesObject && this.languagesObject.data && this.languagesObject.data.data || [] },

    // loading
    excludeOutletsIsBusy() { return this.excludeOutlets && this.excludeOutlets.isBusy },
    includeOutletsIsBusy() { return this.includeOutlets && this.includeOutlets.isBusy },
    includeOutletGroupsIsBusy() { return this.includeOutletGroups && this.includeOutletGroups.isBusy },
    excludeOutletGroupsIsBusy() { return this.excludeOutletGroups && this.excludeOutletGroups.isBusy },
    includeInfluencersIsBusy() { return this.includeInfluencers && this.includeInfluencers.isBusy },
    includeInfluencersIsInitiated() { return this.includeInfluencers && this.includeInfluencers.isInitiated },

    //twitterLanguages
    twitterLanguagesData() { return this.twitterLanguages.data || []},
    twitterFiltersData() {
      let data;
      if (this.model.search_type === 'x_netfeedr') {
        data = this.searchTermsFilters.data;
      } else if (this.model.search_type === 'x_netfeedr_channel') {
        data = this.XChannelFilters.data;
      } else {
        // twitter, twitter_search_v3, etc. use the standard Twitter API operators
        data = this.twitterFilters.data;
      }
      return data || [];
    },
    twitterSearchesData() { 
      const dedupedOptions = new Map();

      this.twitterSearches.data.forEach((data) => {
        const value = data.id;
        dedupedOptions.set(value, { label: data.name + " | " + data.id, value });
      });

      this.selectedTwitterSearches.forEach((option) => {
        if (option?.value && !dedupedOptions.has(option.value)) {
          dedupedOptions.set(option.value, option);
        }
      });

      return Array.from(dedupedOptions.values());
    },

    // either languages or twitterLanguages based on search_type
    resolvedLanguages() { return ['twitter', 'x_netfeedr', 'x_netfeedr_channel', 'twitter_search_v3'].indexOf(this.selectedSearchType.value) > -1 ? this.twitterLanguagesData : this.languages },

    countriesAreBusy() { return this.countriesObject.isBusy },
    countries() { return this.countriesObject && this.countriesObject.data && this.countriesObject.data.data && this.countriesObject.data.data.data || []},
    // Tags
    tagsData() { return this.tags.data || []},

    // Media Types
    mediaTypesData() { return this.mediaTypesObject && this.mediaTypesObject.data || [] },

    // Outlet Categories
    outletCategoriesData() { return this.outletCategories && this.outletCategories.data || [] },
    // Outlets
    includeOutletsData() { return this.includeOutlets.data || [] },
    excludeOutletsData() { return this.excludeOutlets.data || [] },

    //outletGroups
    includeOutletGroupsData() { return this.includeOutletGroups.data || []},
    excludeOutletGroupsData() { return this.excludeOutletGroups.data || []},

    //states
    includeStates() { return this.model && this.model.include_states || [] },
    excludeStates() { return this.model && this.model.exclude_states || [] },

    // available resources (not selected in the counter part list)
    availableIncludeLanguages() { return this.resolvedLanguages.filter(language => !(this.model.exclude_languages || []).includes(language.alpha_2_code)) },
    availableExcludeLanguages() { return this.resolvedLanguages.filter(language => !(this.model.include_languages || []).includes(language.alpha_2_code)) },
    availableIncludeLocations() { return this.countries && (_.get(this, 'model.exclude_locations') ? this.countries.filter(location => !this.model.exclude_locations.includes(location.alpha_2_code)) : this.countries) || [] },
    availableExcludeLocations() { return this.countries && (_.get(this, 'model.locations') ? this.countries.filter(location => !this.model.locations.includes(location.alpha_2_code)) : this.countries) || [] },
    availableOutlets() { return _.get(this, 'model.exclude_outlet_ids') && this.includeOutletsData.filter(outlet => outlet && !this.model.exclude_outlet_ids.includes(outlet.value)) || [] },
    availableExcludeOutlets() { return _.get(this, 'model.include_outlet_ids') && this.excludeOutletsData.filter(outlet => outlet && !this.model.include_outlet_ids.includes(outlet.value)) || [] },
    availableOutletGroups() { return _.get(this, 'model.exclude_outlet_group_ids') && this.includeOutletGroupsData.filter(group => group && !this.model.exclude_outlet_group_ids.includes(group.value)) || [] },
    availableExcludeOutletGroups() { return _.get(this, 'model.outlet_group_ids') && this.excludeOutletGroupsData.filter(group => group && !this.model.outlet_group_ids.includes(group.value)) || [] },

    availableIncludeStates() { return this.states.filter(state => !this.excludeStates.includes(state.state)) },
    availableExcludeStates() { return this.states.filter(state => !this.includeStates.includes(state.state)) },

    // Influencers
    includeInfluencersData() { return this.includeInfluencers.data || [] },

    availableIncludeUsers() { return (this.model && this.model.include_users || []).map(v => ({ value: v, label: v })) },
    availableExcludeUsers() { return (this.model && this.model.exclude_users || []).map(v => ({ value: v, label: v })) },

    availableMustIncludeTerms() { return (this.model && this.model.must_include_terms || []).map(v => ({ value: v, label: v })) },
    availableShouldIncludeTerms() { return (this.model && this.model.should_include_terms || []).map(v => ({ value: v, label: v })) },
    availableMustExcludeTerms() { return (this.model && this.model.must_exclude_terms || []).map(v => ({ value: v, label: v })) },

    detailsFieldsAdditions() {
      const multiple = this.model.is_multi;
      const isCarmaBroadcast = this.model.search_type === 'carma_broadcast';
      
      const additions = {
        multiSyntax: {
          disabled: !!this.item_id,
          inputWrapperClass: 'inline-checkbox',
          style: 'margin-top: 30px; width: 130px;'
        },
        boolSearchType: {
          name: 'search_type',
          options: multiple ?
            searchTypes.filter(type => type.allowMulti && (Array.isArray(type?.isEnabledKeys) ? this?.isProjectEnabledKeys(type) : true))
            : searchTypes?.filter(type => Array.isArray(type?.isEnabledKeys) ? this?.isProjectEnabledKeys(type) : true),
          disabled: !!this.item_id && !multiple,
          preselectFirst: !!this.item_id && !multiple,
          multiple: multiple,
        }
      };

      // Add apply_cbs_outlet_timeframes toggle only for carma_broadcast searches
      if (isCarmaBroadcast) {
        additions.apply_cbs_outlet_timeframes = {
          showTooltip: true,
          tooltipText: this.$t('booleanSearch.details.fields.apply_cbs_outlet_timeframes_description')
        };
      }

      return additions;
    },

    tagDetailsFieldsAdditions(){
      return {
        multiSyntax: {
          disabled: !!this.item_id,
          inputWrapperClass: 'inline-checkbox',
          style: 'margin-top: 30px; width: 130px;'
        },
        boolTagCategory: {
          name: 'category',
          options: this.tagCategories.data,
        }
      }
    },
    disableStates() { return this.model.exclude_locations && this.model.exclude_locations.includes("US")
      || this.model.locations && this.model.locations.length && !this.model.locations.includes('US') },

    bioLocationOptions () {
      const options = (this.availableIncludeLocations || []).map(l => ({ value: l.name, label: l.name }));
      options.push(...this.bioLocationTags);
      return options;
    },
    socialInfluencerOptions () {
      return SOCIAL?.INFLUENCER_MEDIA_TYPES?.map(type => ({ name: this.$t(type.label), value: type.value }));
    },

    filtersFieldsAdditions() {
      const project_id = this.project_id;
      const usedTerms = (this.model.must_include_terms || []).length + (this.model.should_include_terms || []).length;
      const maxTermsReached = usedTerms >= searchTermsCountLimit;
      const searchTermsHint = `${usedTerms} / ${searchTermsCountLimit}`;
      const searchTermsWarning = maxTermsReached ? this.$t('booleanSearch.search_terms_count_limit', { count: searchTermsCountLimit }) : '';
      const disabled = this.isDisabled;
      return {
        includeLanguages: {
          name: 'include_languages',
          optionLabel: 'name',
          optionValue: 'alpha_2_code',
          options: this.availableIncludeLanguages || [],
          style: this.getLastElementStyle('includeLanguages'),
          disabled: disabled
        },
        excludeLanguages: {
          name: 'exclude_languages',
          optionLabel: 'name',
          optionValue: 'alpha_2_code',
          options: this.availableExcludeLanguages || [],
          style: this.getLastElementStyle('excludeLanguages'),
          disabled: disabled
        },
        socialInfluencer: {
          name: 'social_influencer',
          options: this.socialInfluencerOptions || [],
          style: this.getLastElementStyle('socialInfluencer'),
          disabled: disabled,
          validate: [VALIDATIONS.REQUIRED]
        },
        includeInfluencers: {
          name: 'include_influencer_group_ids',
          loading: this.includeInfluencersIsBusy,
          onSearchChange: function(value) {
            this.$store.commit('booleanSearch/SET_FILTER_PARAM', {key: 'include_influencers', param: {key: 'search', value}})
            this.$store.dispatch('booleanSearch/searchGenericPaginatedResource', {
              key: 'include_influencers',
              url: 'influencer_group',
              extraFilters: {
                order: 'name',
                sort: 'asc'
              },
              selectedOptions: this.selected,
              dataProp: 'group_id'
            }).catch(() => this.notifyStoreError())
          },
          disabled: disabled,
          optionLabel: 'group_name',
          optionValue: 'group_id',
          options: this.mergeByProperty(this.includeInfluencersData, _.get(this.item, 'filters.social_influencer.values.include_influencer_group_ids', this.influencerGroups) || [], 'group_id'),
          style: this.getLastElementStyle('includeInfluencers')
        },
        locations: {
          name: 'locations',
          options: this.availableIncludeLocations || [],
          style: this.getLastElementStyle('locations'),
          translate_label: `booleanSearch.filters.fields.locations${typeof this?.model?.search_type === 'string' && ['twitter', 'twitter_search_v3'].includes(this?.model?.search_type?.toLowerCase()) && this?.model?.deep_search_location ? 'Biolocation' : ''}
`,
          disabled: disabled
        },
        twitterMinFollowers: {
          name: 'twitter_min_followers',
          disabled: disabled
        },
        biolocations: {
          name: 'biolocations',
          options: this.bioLocationOptions,
          style: this.getLastElementStyle('biolocations'),
          onTag: ({ label, value }) => {
            this.bioLocationTags.push({ label, value });
          },
          disabled: disabled
        },
        deepSearchLocation: {
          name: 'deep_search_location',
          disabled: disabled
        },
        minFollowerBiolocation: {
          name: 'min_follower_biolocation',
          disabled: disabled
        },
        excludeLocations: {
          name: 'exclude_locations',
          options: this.availableExcludeLocations || [],
          style: this.getLastElementStyle('excludeLocations'),
          disabled: disabled
        },
        includeStates: {
          name: 'include_states',
          options: this.availableIncludeStates || [],
          disabled: this.disableStates || false,
          style: this.getLastElementStyle('includeStates')
        },
        excludeStates: {
          name: 'exclude_states',
          options: this.availableExcludeStates || [],
          disabled: this.disableStates || false,
          style: this.getLastElementStyle('excludeStates')
        },
        includeOutlets: {
          name: 'include_outlet_ids',
          loading: this.includeOutletsIsBusy,
          onSearchChange: function(value) {
            this.$store.commit('booleanSearch/SET_FILTER_PARAM', {key: 'include_outlets', param: {key: 'query', value}})
            this.$store.dispatch('booleanSearch/searchGenericPaginatedResource', {
              key: 'include_outlets',
              url: 'outlets',
              extraFilters: {
                order: 'label',
                sort: 'asc'
              },
              selectedOptions: this.selected
            }).catch(() => this.notifyStoreError())
          },
          disabled: disabled,
          options: this.mergeByProperty(this.availableOutlets, _.get(this.item, 'filters.outlets.values.include_outlet_ids') || [], 'value'),
          style: this.getLastElementStyle('includeOutlets')
        },
        excludeOutlets: {
          name: 'exclude_outlet_ids',
          loading: this.excludeOutletsIsBusy,
          disabled: disabled,
          onSearchChange: function(value) {
            this.$store.commit('booleanSearch/SET_FILTER_PARAM', {key: 'exclude_outlets', param: {key: 'query', value}})
            this.$store.dispatch('booleanSearch/searchGenericPaginatedResource', {
              key: 'exclude_outlets',
              url: 'outlets',
              extraFilters: {
                order: 'label',
                sort: 'asc'
              },
              selectedOptions: this.selected
            }).catch(() => this.notifyStoreError())
          },
          options: this.mergeByProperty(this.availableExcludeOutlets, _.get(this.item, 'filters.outlets.values.exclude_outlet_ids') || [], 'value'),
          style: this.getLastElementStyle('excludeOutlets')
        },
        includeOutletGroups: {
          name: 'outlet_group_ids',
          disabled: disabled,
          loading: this.includeOutletGroupsIsBusy,
          onSearchChange: function(value) {
            this.$store.commit('booleanSearch/SET_FILTER_PARAM', {key: 'include_outlet_groups', param: {key: 'query', value}})
            this.$store.dispatch('booleanSearch/searchGenericPaginatedResource', {
              key: 'include_outlet_groups',
              url: 'outlets/outlet_groups',
              extraFilters: {
                order: 'label',
                sort: 'asc',
                project_id: project_id
              },
              selectedOptions: this.selected
            }).catch(() => this.notifyStoreError())
          },
          options: this.mergeByProperty(this.availableOutletGroups, _.get(this.item, 'filters.outlet_groups.values.outlet_group_ids') || [], 'value'),
          style: this.getLastElementStyle('includeOutletGroups')
        },
        excludeOutletGroups: {
          name: 'exclude_outlet_group_ids',
          disabled: disabled,
          loading: this.excludeOutletGroupsIsBusy,
          onSearchChange: function(value) {
            this.$store.commit('booleanSearch/SET_FILTER_PARAM', {key: 'exclude_outlet_groups', param: {key: 'query', value}})
            this.$store.dispatch('booleanSearch/searchGenericPaginatedResource', {
              key: 'exclude_outlet_groups',
              url: 'outlets/outlet_groups',
              extraFilters: {
                order: 'label',
                sort: 'asc',
                project_id: project_id
              },
              selectedOptions: this.selected
            }).catch(() => this.notifyStoreError())
          },
          options: this.mergeByProperty(this.availableExcludeOutletGroups, _.get(this.item, 'filters.outlet_groups.values.exclude_outlet_group_ids') || [], 'value'),
          style: this.getLastElementStyle('excludeOutletGroups')
        },
        includeMediaSubtypes: {
          name: 'media_subtypes',
          disabled: disabled,
          options: this.mediaTypesData || [],
          style: this.getLastElementStyle('includeMediaSubtypes')
        },
        boolOutletCategories: {
          name: 'categories',
          disabled: disabled,
          options: this.outletCategoriesData || [],
          style: this.getLastElementStyle('boolOutletCategories')
        },
        twitterFilter: {
          name: 'twitter_filters',
          options: this.twitterFiltersData || [],
          disabled: disabled
        },
        twitterSearches: {
          name: 'twitter_searches',
          disabled: disabled,
          options: this.twitterSearchesData || []
        },
        keywords: {
          name: 'keywords',
          disabled: disabled,
          options: this.getKeywordsOptions(),
          style: this.getLastElementStyle('keywords')
        },
        searchTermsFilter: {
          name: 'twitter_filters', // same name as twitterFilter
          disabled: disabled,
          options: this.searchTermsFiltersData || []
        },
        includeUsers: {
          name: 'include_users',
          disabled: disabled,
          options: this.availableIncludeUsers,
          disableWhiteSpace: true,
          lowerCase: true,
          isTaggingAllowed: (value) => !this.isTagDuplicated(value, 'include_users'),
          validate: this.model.search_type === 'x_netfeedr_channel' ? [VALIDATIONS.REQUIRED] : []
        },
        excludeUsers: {
          name: 'exclude_users',
          disabled: disabled,
          options: this.availableExcludeUsers,
          disableWhiteSpace: true,
          lowerCase: true,
          isTaggingAllowed: (value) => !this.isTagDuplicated(value, 'exclude_users')
        },
        mustIncludeTerms: {
          name: 'must_include_terms',
          disabled: disabled,
          validate: [VALIDATIONS.REQUIRED, VALIDATIONS.CUSTOM],
          options: this.availableMustIncludeTerms,
          style: 'grid-column: 1 / span 2',
          hint: searchTermsHint,
          helperText: searchTermsWarning,
          isTaggingAllowed: () => {
            return !maxTermsReached;
          }
        },
        shouldIncludeTerms: {
          name: 'should_include_terms',
          disabled: disabled,
          options: this.availableShouldIncludeTerms,
          style: 'grid-column: 1 / span 2',
          hint: searchTermsHint,
          helperText: searchTermsWarning,
          isTaggingAllowed: () => {
            return !maxTermsReached;
          }
        },
        mustExcludeTerms: {
          name: 'must_exclude_terms',
          disabled: disabled,
          options: this.availableMustExcludeTerms,
          style: 'grid-column: 1 / span 2'
        }
      }
    },

    queryFieldsAdditions() {
      const model = this.model;
      const isDisabled = this.isDisabled;
      const groupFields = _.get(this.selectedSearchType, 'queries') || ['query', 'regex_query', 'user_query', 'standard_query'];
      const validations = model.searches?.length ? [VALIDATIONS.QUERYEDITOR_SYNTAX] : [VALIDATIONS.REQUIRE_ONE_OF, VALIDATIONS.QUERYEDITOR_SYNTAX];
      
      let generateQueryProp = {};
      if((!model.standard_query || _.isEmpty(model.standard_query)) &&
        (model.must_include_terms?.length || model.should_include_terms?.length || model.must_exclude_terms?.length || model.include_users?.length || model.exclude_users?.length)) {
        generateQueryProp = { generateQuery: this.createAfterFilter };
      }

      if(model.search_type === 'asian' || model.search_type?.includes('asian')) {
        validations.push(VALIDATIONS.QUERYEDITOR_ASIAN_SYNTAX)
      }

      return {
        query: {
          group_fields: groupFields,
          disabled: isDisabled,
          validate: validations
        },
        regex_query: {
          group_fields: groupFields,
          disabled: isDisabled,
          validate: validations
        },
        user_query: {
          group_fields: groupFields,
          disabled: isDisabled,
          validate: validations
        },
        standard_query: {
          group_fields: groupFields,
          disabled: isDisabled,
          validate: validations
        },
        media_track_query: {
          // No group_fields needed - this is read-only and shouldn't be validated
        },
        twitter_standard_query: {
          disabled: isDisabled,
          validate: validations,
          ...generateQueryProp
        },
        multi_provider_standard_query: {
          validate: validations
        }
      }
    }
  },

  methods: {
    ...mapActions({
      getLanguages    : "languages/getLanguages",
      getCountries    : "countries/getCountries",
      getOutletGroups : "outletGroups/getOutletGroups",
      getGroupsByProjectId: "influencerGroups/getGroupsByProjectId"
    }),

    isProjectEnabledKeys(type = {}) {
      return Array.isArray(type?.isEnabledKeys) && type?.isEnabledKeys?.length > 0 && type?.isEnabledKeys?.filter(k => !!this.projectSetupGeneral?.[k])?.length === type?.isEnabledKeys?.length;     
    },

    isTagDuplicated (value, field) {
      const val = ('' + value).replace(/\s+/g, '').toLowerCase();
      return (this.model[field] || []).indexOf(val) > -1;
    },

    prefillTagOptions () {
      const currentBiolocations = _.get(this.model, 'biolocations') || [];
      const textOptions = currentBiolocations.filter(val => !this.bioLocationOptions.find(opt => opt.value === val)).map(val => ({ value: val, label: val }));
      this.bioLocationTags.push(...textOptions);
    },

    mergeByProperty(target, source, prop) {
      let result = _.cloneDeep([...target])
      source.forEach(sourceElement => {
        let targetElement = result.find(targetElement => {
          return sourceElement[prop] === targetElement[prop];
        })
        targetElement ? Object.assign(targetElement, sourceElement) : result.push(sourceElement);
      })
      return result
    },

    getKeywordsOptions () {
      return (_.get(this.model, 'keywords') || []).map(value => ({value: value, label: value}));
    },

    getLastElementStyle (fieldKey) {
      if(_.get(this.selectedSearchType, 'fields')) {
        const searchFilterFields = this.selectedSearchType.fields.filter(field => INPUT_FIELDS[field]);
        if(searchFilterFields.indexOf(fieldKey) === searchFilterFields.length -1 && searchFilterFields.length % 2 !== 0) {
          return 'grid-column: 1 / -1;'
        }
      }

      return '';
    },

    createAfterFilter() {
      const parts = [];
      const cleanTerm = term => `"${term}"`;

      if(this.model.must_include_terms?.length) {
        parts.push(this.model.must_include_terms.map(cleanTerm).join(' AND '));
      }
      if(this.model.should_include_terms?.length) {
        parts.push(`(${this.model.should_include_terms.map(cleanTerm).join(' OR ')})`);
      }
      if(this.model.must_exclude_terms?.length) {
        parts.push(`NOT (${this.model.must_exclude_terms.map(cleanTerm).join(' OR ')})`);
      }
      if(this.model.include_users?.length) {
        parts.push(`(` + this.model.include_users.map(t => "from:" + cleanTerm(t)).join(' OR ') + `)`);
      }
      if(this.model.exclude_users?.length) {
        parts.push(`NOT (` + this.model.exclude_users.map(t => "from:" + cleanTerm(t)).join(' OR ') + `)`);
      }

      if (typeof this.updateModel === 'function') {
        this.updateModel({ standard_query: parts.join(' AND ') }, { name: 'standard_query' });
      }
    }
  },

  watch: {
    twitterSearchesData (val, prev) {
      const valValues = val.map(item => item.value);
      const prevValues = prev.map(item => item.value);
      
      if (!_.isEqual(valValues.sort(), prevValues.sort())) {
        const dedupedSelected = new Map();

        [...this.selectedTwitterSearches, ...prev].forEach((option) => {
          if (this.model.twitter_searches.indexOf(option.value) > -1 && !dedupedSelected.has(option.value)) {
            dedupedSelected.set(option.value, option);
          }
        });

        this.selectedTwitterSearches = Array.from(dedupedSelected.values());
      }
    }
  }
}
